import React from 'react'
import { ThemeSwitcher } from 'widgets/theme-switcher'
import { useAuth } from '@morningtrain/react-auth'
import { observer } from 'mobx-react'
import Permissions from 'services/Permissions'
import { useTranslation } from '@morningtrain/react-translations'
import * as UI from 'ui'

function ManageUserNavigationTabs () {
  const auth = useAuth()

  const options = []

  const canViewContracts = auth.can(Permissions.CONTRACTS_VIEW)
  const canManageUsersFull = auth.can(Permissions.EMPLOYMENTS_MANAGE_USERS_FULL)

  const editTrans = useTranslation('hr.users.tabs.edit')
  const contractsTrans = useTranslation('hr.users.tabs.contracts')
  const workPermitsTrans = useTranslation('hr.users.tabs.work_permits')

  if (!canViewContracts && !canManageUsersFull) {
    return null
  }

  options.push({
    value: 'edit',
    label: editTrans
  })

  if (canViewContracts) {
    options.push({
      value: 'contracts',
      label: contractsTrans
    })
  }

  if (canManageUsersFull) {
    options.push({
      value: 'work_permits',
      label: workPermitsTrans
    })
  }

  return (
          <>
            <UI.ButtonTabs>
              {options.map(option => (
                      <ThemeSwitcher
                              key={option.value}
                              type={option.value}
                              label={option.label}
                      />
              ))}
            </UI.ButtonTabs>
          </>
  )
}

export default observer(ManageUserNavigationTabs)
